
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import {
    materialHairRingMaterialmaterialHairRingMaterialPageList,
    materialHairRingMaterialmaterialHairRingMaterialDelete
  } from "@/api/material"
	import Message from '@/components/message.vue'
	import{
		getSearchDate,
		nextDay
	}from "@/utils/index"
  @Component({  
    name: '',
    components: {
      PageFooter,
      Message
    }
  })

  export default class ProductList extends Vue {
    private pageNo = 1;
		private pageSize = 10;
		private total = 0;
    private timeValue:any = []
    private keyWords = ''
    private tablelist:any = []
    private tableloading = false

    private rowMsg:any = {}
    private delShow = false

    private mounted (){
      this.timeValue = [getSearchDate(2,false,-29)[0],getSearchDate(2)[0]]
      this.gettablelist()
    }
    activated () {
      this.gettablelist()
    }

    private async confirmDelete(row){
      try{
        let res = await materialHairRingMaterialmaterialHairRingMaterialDelete({
          Id:this.rowMsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.delShow = false
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private delrow(row){
      this.rowMsg = row
      this.delShow = true
    }
    private editmaterial(row){
      this.$router.push({
        path:'material-circleDetail',
        query:{
          Id:row.Id
        }
      })
    }
    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.pageNo = 1
      this.keyWords = ''
      this.timeValue = [getSearchDate(2,false,-29)[0],getSearchDate(2)[0]]
      this.doSearch()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keyWords,
          StartTime:'',
          EndTime:'',
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if(this.timeValue&&this.timeValue.length){
          data.StartTime = this.timeValue[0]
          data.EndTime = nextDay(this.timeValue[1],1)
        }
        let res = await materialHairRingMaterialmaterialHairRingMaterialPageList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
